<template>
  <div class="page">
    <!-- 活跃任务 · 以及Og任务背景图 -->
    <div class="task">
      <div class="task-top">
        <!-- 背景图 -->
        <div class="task-top-background" v-show="currentShow === 1">
          <div class="task-top-background-title">{{ localesPackage?.['katharsis_title']?.[localesEnv] }}</div>
          <!-- 活跃任务 · 周任务 等级 进度 -->
          <div class="task-top-main" v-show="currentShow === 1">
            <div class="jindu">
              <!-- 等级 -->
              <div class="level" id="levelTxView">
                <div class="level-lv longTouch" id="levelTx1">
                  <span class="level-lv-l" id="levelTx-l">L</span>
                  <span class="level-lv-v" id="levelTx-v">v</span>
                  <span class="level-lv-dot" id="levelTx-dot">.</span>
                  <span class="level-lv-level longTouch" id="levelTx2">
                    {{ cur_level }}
                  </span>
                </div>
              </div>
              <div class="jindu-limit longTouch">
                <span class="jindu-limit-title">{{ localesPackage?.['katharsis_exp_limit']?.[localesEnv] }}</span>
                {{ cur_weekly_kep > 5000 ? 5000 : cur_weekly_kep }}/5000
              </div>
              <Progress
                :cur_kep="cur_upgrade_kep"
                :total_kep="total_upgrade_kep"
                :isFull="cur_level >= max_level"
              ></Progress>
            </div>
          </div>
        </div>
        <!-- 返回和介绍 -->
        <div
          class="task-top-header"
          :style="{ paddingTop: 9 + statusBarHeight + 'px' }"
        >
          <!-- 返回按钮 -->
          <div class="task-top-header-return" @click="handleClosePage">
            <img
              :src="
                require('@/assets/images/YuliApp/weeklyTask/button_return.svg')
              "
            />
          </div>
          <!-- switchTag v-if="ogConfig.is_og_enabled" -->
          <div class="task-top-header-switch">
            <div class="task-top-header-switch-item task-top-header-switch-left" 
                :class="{active: currentShow === 1}"
                @click="switchTagHanlde(1)">
                {{ localesPackage?.['katharsis_page']?.[localesEnv] }}
                <div class="task-top-header-switch-unClaimed" v-if="red_reward_show || red_mission_show">
                  <img
                    :src="
                      require('@/assets/images/YuliApp/weeklyTask/gantanhao.svg')
                    "
                  />
                </div>
            </div>
            <div class="task-top-header-switch-item task-top-header-switch-right"
                :class="{active: currentShow === 2}"
                @click="switchTagHanlde(2)">
                {{ localesPackage?.['og_page']?.[localesEnv] }}
                <div class="task-top-header-switch-unClaimed" v-if="ogConfig.is_og_claimable && ogConfig?.stars > 0 && ogConfig?.unlock_secs == 0">
                  <img
                    :src="
                      require('@/assets/images/YuliApp/weeklyTask/gantanhao.svg')
                    "
                  />
                </div>
            </div>
          </div>
          <!-- 介绍按钮 -->
          <div class="task-top-header-introduce" @click="handleMsgPopHandle('rules')">
            <img
              :src="require('@/assets/images/YuliApp/weeklyTask/wenhao.svg')"
            />
          </div>
        </div>
      </div>

      <!-- 活跃任务 · 任务奖励和每日任务-->
      <div class="task-bottom" v-show="currentShow === 1">
        <!--  -->
        <div class="task-bottom-height"></div>
        <!-- tab栏 -->
        <div class="task-bottom-tab">
          <div
            class="task-bottom-tab-reward task-bottom-tab-shape longTouch"
            :class="{ seleced: tabStyle === 'reward' }"
            @click="handleSelect('reward')"
          >
            <div class="task-bottom-tab-mission-text"
                :class="{'text-active': tabStyle === 'reward'}">
                {{ localesPackage?.['katharsis_reward']?.[localesEnv] }}
            </div>
            <img v-show="tabStyle === 'reward'" class="chooseBg" :src="require('@/assets/images/YuliApp/weeklyTask/choose_reward.png')">
            <img v-show="tabStyle === 'mission'" class="chooseBg" :src="require('@/assets/images/YuliApp/weeklyTask/unchoose_reward.png')">
            <div class="unClaimed" v-if="red_reward_show">
              <img
                :src="
                  require('@/assets/images/YuliApp/weeklyTask/gantanhao.svg')
                "
              />
            </div>
          </div>
          <div
            class="task-bottom-tab-mission longTouch"
            :class="{ seleced: tabStyle === 'mission' }"
            @click="handleSelect('mission')"
          >
            <img v-show="tabStyle === 'reward'" class="unchooseBg" :src="require('@/assets/images/YuliApp/weeklyTask/unchoose_mission.png')">
            <img v-show="tabStyle === 'mission'" class="choose-misson" :src="require('@/assets/images/YuliApp/weeklyTask/choose_mission.png')">
            <div class="task-bottom-tab-mission-text"
                :class="{'text-active': tabStyle === 'mission'}">
                {{ localesPackage?.['katharsis_missions']?.[localesEnv] }}
            </div>
            <div class="unClaimed" v-if="red_mission_show">
              <img
                :src="
                  require('@/assets/images/YuliApp/weeklyTask/gantanhao.svg')
                "
              />
            </div>
          </div>
          <!-- 一键领取按钮 -->
          <div class="task-bottom-button"
              :class="{'task-bottom-buttonActive': red_reward_show}"
              @click="debounce(receiveInFullHandle,400)()">
              {{ localesPackage?.['katharsis_receive_full']?.[localesEnv] }}
          </div>
        </div>

        <!-- 内容 -->
        <div class="task-bottom-content">
          <!-- 倒计时 -->
          <div class="task-bottom-content-timeview" v-show="tabStyle === 'reward' && rewardData?.length > 0">
            <CountDown :begin_time="begin_time" :end_time="end_time"></CountDown>
          </div>
          <RewardPage
            v-show="tabStyle === 'reward'"
            :curLevel="cur_level"
            :period_id="period_id"
            :cur_claimed_level="cur_claimed_level"
            :reward_data="rewardData"
            :isClaiming="isClaiming"
            :isLockUpgraded="isLockUpgraded"
            :proMode="Number(arg_use.need) > 0"
            :animCheckPlayGroup="rewardAnimConfig?.animGroup"
            @rewardClick="handleRewardClick"
            @claiming="handleClaiming"
          ></RewardPage>
          <MissionsPage
            v-show="tabStyle === 'mission'"
            :period_id="period_id"
            :missionData="missionData"
            :isClaiming="isClaiming"
            @handleMissionsClaim="handleMissionsClaim"
            @claiming="handleClaiming"
          ></MissionsPage>
        </div>

        <!-- 介绍弹窗 -->
        <ActivityIntro
          v-if="isShowRules"
          @close="showActivityIntro"
        ></ActivityIntro>

        <!-- 动画弹窗 -->
        <!-- 光效动画  -->
        <AnimateLight
          :cur_level="cur_level_anim"
          v-show="isShowFlowerAnimate"
          @close="handleCloseFlower"
          :isShow="isShowFlowerAnimate"
        ></AnimateLight>
      </div>
    </div>
    <!-- OG任务 -->
    <div class="og" v-show="currentShow === 2">
      <div class="og-background"></div>
      <!-- banner -->
      <div class="og-banner-Tag" :style="ogTopStyle?.['og-banner-Tag']">
        <img :src="require('@/assets/images/YuliApp/weeklyTask/og-label.png')">
        <div class="og-banner-Tag-text">OG Exclusive</div>
      </div>
      <div class="og-banner-title"
          :style="ogTopStyle?.['og-banner-title']">
        {{ localesPackage?.['og_title']?.[localesEnv] }}
      </div>
      <!-- 等级 · 层 -->
      <div class="og-level" :style="ogTopStyle?.['og-level']">
        <!-- 背景图 -->
        <img :src="require('@/assets/images/YuliApp/weeklyTask/og-level.png')">
        <!-- 星图 -->
        <div class="og-level-starbox">
          <!-- 1 -->
          <img class="og-level-starbox-1" :src="require('@/assets/images/YuliApp/weeklyTask/star_on.png')" v-if="ogConfig.stars >= 1">
          <img class="og-level-starbox-1" :src="require('@/assets/images/YuliApp/weeklyTask/star_off.png')" v-else>
          <!-- 2 -->
          <img class="og-level-starbox-2" :src="require('@/assets/images/YuliApp/weeklyTask/star_on.png')" v-if="ogConfig.stars >= 2">
          <img class="og-level-starbox-2" :src="require('@/assets/images/YuliApp/weeklyTask/star_off.png')" v-else>
          <!-- 3 -->
          <img class="og-level-starbox-3" :src="require('@/assets/images/YuliApp/weeklyTask/star_on.png')" v-if="ogConfig.stars >= 3">
          <img class="og-level-starbox-3" :src="require('@/assets/images/YuliApp/weeklyTask/star_off.png')" v-else>
          <!-- 4 -->
          <img class="og-level-starbox-4" :src="require('@/assets/images/YuliApp/weeklyTask/star_on.png')" v-if="ogConfig.stars >= 4">
          <img class="og-level-starbox-4" :src="require('@/assets/images/YuliApp/weeklyTask/star_off.png')" v-else>
          <!-- 5 -->
          <img class="og-level-starbox-5" :src="require('@/assets/images/YuliApp/weeklyTask/star_on.png')" v-if="ogConfig.stars >= 5">
          <img class="og-level-starbox-5" :src="require('@/assets/images/YuliApp/weeklyTask/star_off.png')" v-else>
        </div>
        <!-- 遮罩层 -->
        <div class="og-level-mask" v-if="ogConfig.unlock_secs > 0 || ogConfig.stars === 0">
          <img :src="require('@/assets/images/YuliApp/weeklyTask/shade.svg')">
          <!-- 锁 -->
          <img v-if="ogConfig.stars === 0" class="og-level-mask-lock" :src="require('@/assets/images/YuliApp/weeklyTask/white_lock.svg')">
          <!-- 倒计时 -->
          <OgLockTimer v-if="ogConfig.unlock_secs > 0" :unlock_secs="ogConfig.unlock_secs" @timeout="ogTimeHandle"></OgLockTimer>
        </div>
        <!-- <div class="og-level-title">OG</div>
        <div class="og-level-lv">{{ `${ogConfig.stars > 0 ? `lv.${ogConfig.stars}` : 'non'}` }}</div> -->
      </div>
      <!-- 倒计时 -->
      <OgCountDown :ogStyle="ogTopStyle?.['countdown']" :begin_time="ogConfig.begin_time" :end_time="ogConfig.end_time" :total_day="ogConfig.cumulative_sign_in"></OgCountDown>
      <!-- 描述 · 层 -->
      <div class="og-desc" :style="ogTopStyle?.['og-desc']">
        <!-- OG玩家 -->
        <div v-if="ogConfig.stars > 0 && ogConfig.unlock_secs === 0">{{ localesPackage?.['og_about2']?.[localesEnv] }}</div>
        <!-- 非OG玩家 - 非冻结 -->
        <div v-if="ogConfig.stars === 0">
          <div>{{ localesPackage?.['og_about']?.[localesEnv] }}</div>
          <div class="og-desc-link" @click="disOgPlayerHandle">{{ localesPackage?.['og_get_method']?.[localesEnv] }}</div>
        </div>
        <!-- 冻结 -->
        <div v-if="ogConfig.unlock_secs > 0">
          <div>{{ localesPackage?.['og_about3']?.[localesEnv] }}</div>
        </div>
      </div>
      <!-- 领奖层 -->
      <div class="og-reward" :style="ogTopStyle?.['og-reward']">
        <!-- 补充树枝 -->
        <div class="og-reward-branch"></div>
        <!-- 正常 道具列表 -->
        <div class="og-reward-proplist" v-if="ogConfig.rewardData.length !== 0">
          <div class="og-reward-proplist-prop"
              v-for="item in ogConfig.rewardData"
              @click="ogPropClickHandle(item)"
              :key="item.prop_id + item.id + ''">
              <!-- 底图 -->
              <div class="og-reward-proplist-prop-bg"
                  :class="[{
                    five: item.level % 5 === 0,
                    //'og-reward-proplist-prop-bg-receive': item.level === ogConfig.cumulative_sign_in + 1  && ogConfig?.stars > 0 && ogConfig?.unlock_secs == 0 && ogConfig?.is_claimable,
                  }]">
              </div>
              <!-- 强调白框 -->
              <div class="og-reward-proplist-prop-bg-receive" v-if="item.level === ogConfig.cumulative_sign_in + 1 && ogConfig?.stars > 0 && ogConfig?.unlock_secs == 0 && ogConfig?.is_claimable"></div>
              <!-- 天数 -->
              <div class="og-reward-proplist-prop-day">Day{{ item.level }}</div>
              <!-- 道具图 -->
              <img class="og-reward-proplist-prop-icon" 
                    :class="[{
                      'og-reward-proplist-prop-icon-mask': ogConfig.stars === 0 || ogConfig?.unlock_secs > 0
                    }]"
                    :src="item.icon_url">
              <!-- 奖励数 -->
              <div class="og-reward-proplist-prop-reward-num">{{ item.reward_num }}</div>
              <!-- 未领取状态 -->
              <div class="og-reward-proplist-prop-unClaimed"
                    v-if="ogConfig?.is_claimable && ogConfig.cumulative_sign_in+1 === item.level && ogConfig?.stars > 0 && ogConfig?.unlock_secs == 0">
                    <img
                      :src="require('@/assets/images/YuliApp/weeklyTask/gantanhao.svg')"
                    />
              </div>
              <!-- 已领取状态 -->
              <div v-if="ogConfig.cumulative_sign_in >= item.level">
                <!-- 领取动画 -->
                <div class="square-with-hole"
                  v-if="cur_popup_info?.[0]?.level == item.level && ogConfig.rewardAnimState">
                  <AnimCheck 
                    :pageStyle="ogConfig.animStyle"
                    @closeAnim="animOgCheckHandle"
                    :isShow="ogConfig.rewardAnimState"
                    :playEffect="true"
                    :removeMask="true"
                  />
                </div>
                <!-- 已领取图标 -->
                <div class="og-reward-proplist-prop-claimed" v-if="cur_popup_info?.[0]?.level != item.level">
                    <img
                      :src="require('@/assets/images/YuliApp/weeklyTask/btn_task_yes2.svg')"
                    />
                </div>
              </div>
          </div>

          <!-- 禁止领取情况 -->
          <div class="og-reward-proplist-disable"
              :style="ogTopStyle?.['og-reward-mask']"
               v-if="ogConfig.unlock_secs > 0 || ogConfig.stars === 0"></div>
        </div>
        <!-- 不存在时·道具列表 -->
        <div class="og-reward-proplist" v-else>
          <div class="og-reward-proplist">
            <div class="og-reward-proplist-prop"
                v-for="num in 40"
                :key="num">
                <!-- 底图 -->
                <div class="og-reward-proplist-prop-bg">
                </div>
            </div>
          </div>
          <!-- 无数据遮罩 -->
          <div class="og-reward-proplist-mask" :style="ogTopStyle?.['og-reward-proplist-none']">
            <img :src="require('@/assets/images/YuliApp/weeklyTask/robot_wait.svg')">
            <div class="og-reward-proplist-mask-text">{{ localesPackage?.['og_no_reward_tips']?.[localesEnv] }}</div>
            <div class="og-reward-proplist-mask-text2">{{ localesPackage?.['og_no_reward_tips2']?.[localesEnv] }}</div>
          </div>
        </div>
      </div>
      <!-- 弹窗 -->
      <!-- 信息弹窗- og专用 -->
      <MessagePopup
          v-if="isShowOgMessagePopup"
          @ogInfoHandle="handleOgMsgPopHandle"
          :popup_type="og_popup_type"
          :error_info="error_info"
        ></MessagePopup>
    </div>
    <!-- 公共弹窗 -->
    <!-- 领取奖励弹窗 -->
    <DrawPopup
      v-if="isShowNotClaim"
      :isShowBotMengban="true"
      :cur_popup_info="cur_popup_info"
      :drawClickType="drawClickType"
      :backImage="
        require('@/assets/images/YuliApp/weeklyTask/reward_block_bg.svg')
      "
      :upBg="
        require('@/assets/images/YuliApp/weeklyTask/rewards_pop_up@2x.png')
      "
      @close="handleShowUnClaim"
    ></DrawPopup>
    <!-- 信息弹窗 - 公共 -->
    <MessagePopup
      v-if="isShowMessagePopup"
      @infoHandle="handleMsgPopHandle"
      :popup_type="popup_type"
      :arg_use="arg_use"
      :pro_prop_list="pro_prop_list"
      :cur_popup_info="cur_popup_info"
      :cur_props_owned="cur_props_owned"
      :error_info="error_info"
    ></MessagePopup>
    <!-- 已领取、未解锁 弹窗 -->
    <ClaimedPopup
      v-if="isShowClaimedLock"
      @close="handleShowClaimedLock"
      @msginfo="handleMsgPopHandle"
      :state="curState"
      :cur_popup_info="cur_popup_info"
      :cur_props_owned="cur_props_owned"
      :mode="cur_mode"
    ></ClaimedPopup>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref, getCurrentInstance, nextTick } from "vue";
import { mapState } from "vuex";
import appBridging from "@/utils/appBridging.js";
import AnimateLight from "./components/AnimateLight";
import Progress from "./components/Progress";
import CountDown from "./components/CountDown";
import OgCountDown from "./components/OgCountDown";
import OgLockTimer from "./components/OgLockTimer";
import RewardPage from "./components/RewardPage";
import MissionsPage from "./components/MissionsPage";
import ActivityIntro from "./components/ActivityIntro";
import DrawPopup from "./components/DrawPopup";
import ClaimedPopup from "./components/ClaimedPopup";
import MessagePopup from "./components/MessagePopup";
import AnimCheck from "./components/RewardPage/components/AnimCheck";
import { TOAST_TYPE } from "@/components/Toast/index.vue";

import {
  REWARD_TYPE,
  TASK_STATE_TYPE,
  DRAW_CLICK_TYPE,
  POPUP_TYPE,
  ERROR_TEXT,
  MISSION_SWITCH_TYPE,
} from "@/constants/enums";
import audioManager from "@/utils/audioManager";
import {
  getTaskReward,
  postUpgrade,
  getOgList,
  postOgRewardClaim,
  postRewardClaim,
  postExpClaim,
} from "@/api/weeklyTask.js";
import { throttle, findIndexByFieldValue, px2rem } from "@//utils/utils.js";
import _ from "lodash";
import {getWeeklyTaskLanguage} from "@/api/language.js";
import store from "@/store";

export default {
  components: {
    AnimateLight,
    Progress,
    CountDown,
    OgCountDown,
    OgLockTimer,
    MissionsPage,
    RewardPage,
    ActivityIntro,
    DrawPopup,
    ClaimedPopup,
    MessagePopup,
    AnimCheck,
  },
  computed: {
    ...mapState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
    ogTopStyle: function () {
      // og顶部组件高度动态适配
      console.log('windows-I: ',window.innerHeight," : ",window.innerWidth);
      console.log('windows-O: ',window.outerHeight," : ",window.outerWidth);
      console.log('statusBarHeight: ', this.statusBarHeight);
      const style = {
        'og-level': {top: px2rem(`${66 + this.statusBarHeight}px`)},
        'og-banner-Tag': {top: px2rem(`${76 + this.statusBarHeight}px`)},
        'og-banner-title': {
          top: px2rem(`${90 + this.statusBarHeight}px`),
          fontSize: this.isIos ? px2rem('32px') : '',
          letterSpacing: this.isIos ? 'unset' : '',
        },
        'countdown': {top: px2rem(`${118 + this.statusBarHeight}px`)},
        'og-desc': {top: px2rem(`${195 + this.statusBarHeight}px`)},
        'og-reward': {height: `calc(100% - ${px2rem(`${269 + this.statusBarHeight }px`)})`},
        'og-reward-mask': {height: `calc(100vh - ${px2rem(`${312 + this.statusBarHeight }px`)})`},
        'og-reward-proplist-none': {height: `calc(100vh - ${px2rem(`${312 + this.statusBarHeight }px`)})`},
      }
      return style;
    },
  },
  watch: {
    init: {
      handler(value) {
        if (!value) {
          return;
        }
        console.log('firstInit');
        this.firstInit();
      },
      immediate: true,
      deep: true,
    },
    currentShow: {
      handler(value) {
        if(value === 2){
          nextTick(()=>{
            // 自动滚动到最新og位置
            const nowNum = this.ogConfig.cumulative_sign_in + (this.ogConfig.is_claimable ? 1 : 0) - 1;  
            const offset = Math.floor(nowNum / 4) * 87;// 87是单行高
            document.querySelector('.og-reward-proplist').scrollTop = offset;
          })
        }
      },
      immediate: true,
      deep: true,
    },
    languageEnv: {
      async handler(value) {
        console.log('languageEnv: ', value);
        if(value){
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        console.log('languagePackage: ', value);
        if(value){
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    }
  },
  setup() {
    const { proxy } = getCurrentInstance();
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref('en');
    const currentShow = ref(1);
    const rewardData = ref([]); //奖励数据
    const missionData = ref([]); //mission数据
    const red_reward_show = ref(false); //控制红点展示
    const red_mission_show = ref(false);
    const tabStyle = ref("reward");
    const period_id = ref(""); //任务周期id

    const cur_total_kep = ref(0); //当前周期累积的所有经验值

    const cur_upgrade_kep = ref(0); //当前升级经验
    const total_upgrade_kep = ref(500); //升级经验上限值

    const cur_weekly_kep = ref(0); //当前经验  一周

    const cur_level = ref(0); //当前等级
    const cur_level_anim = ref(0); //升级动画显示的等级
    const max_level = ref(50); //任务最高等级,默认50;

    /**领奖项打勾动画变量配置 */
    const rewardAnimConfig = ref({
      /**动画播放组 */
      animGroup: [],
      /**当前播放组 */
      nowStep: 0,
      /**每次播放组大小 */
      playSize: 5,
      /**当前播放组是否是pro 1-普通  2-pro */
      playState: 1,
    })

    const cur_claimed_level = ref(1); //当前已领取奖励的等级

    const isShowRules = ref(false);

    const isShowNotClaim = ref(false); //未领取状态
    const isShowClaimedLock = ref(false); //未解锁、已领取状态
    const isShowMessagePopup = ref(false); //消息弹窗
    const popup_type = ref(POPUP_TYPE.UPGRADE); //消息弹窗类型
    const isShowOgMessagePopup = ref(false); //Og消息弹窗
    const og_popup_type = ref(POPUP_TYPE.OG_CONGRATULATE); //消息弹窗类型
    const cur_mode = ref(1);
    const isLockUpgraded = ref(false); //pro升级标志
    const curState = ref(1); //当前点击reward的奖励状态
    const error_info = ref({
      type: 0,
      msg: '',
      platform: ''
    }); //存储错误信息
    const cur_popup_info = ref(null);
    const cur_props_owned = ref(0); //当前道具拥有的数量
    const cur_reward_item = ref(null);//当前处于领奖的物品信息
    const arg_use = ref({ //arg升级信息
      need: 0, //修改这个默认值大于0，则可影响缺省的模式 0 - 普通，大于0 pro
      valueTotal: 0,
    })
    const pro_prop_list = ref([]); //arg升级道具奖励列表
    const isShowFlowerAnimate = ref(true);//升级动画标志
    const curMissionsClaimKep = ref(0); //当前misson 领取经验的数量

    const begin_time = ref(0); //倒计时
    const end_time = ref(0);

    const drawClickType = ref(DRAW_CLICK_TYPE.REWARD); //点击类型
    const isClaiming = ref(false);
    const firstInitTimes = ref(0);// 初始化完成态请求次数
    const isIos = ref(false); // 识别ios机型
    // OG变量配置
    const ogConfig = ref({
      begin_time: 0,
      end_time: 0,
      rewardData: [],
      stars: 0,
      is_claimable: false,
      unlock_secs: 0,
      is_og_claimable: false,
      is_og_enabled: false,
      rewardAnimState: false, //领奖时，播放动画的标志物
      animStyle: {scale: 0.85}
    }); //Og总配置

    onBeforeMount(async ()=>{
      appBridging.getSettingLaungage();
      const res = await getWeeklyTaskLanguage();
      console.log('languagePackage: ',res);
      store.dispatch("global/setLanguagePackage", res);// 存到stroe
    })

    onMounted(() => {
      appBridging.getStatusBarHeight();
      localStorage.setItem("prop_id", "0");
      localStorage.setItem("current_holding", 0);
      
      try {
        // 判断设备类型
        const ua = navigator.userAgent;
        isIos.value =
        !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) || ua.indexOf("Ios") > -1;
      } catch (error) {
        isIos.value = false;
      }

      nextTick(()=>{
        // 升级动画预处理 - 及载入loading控制
        setTimeout(()=>{
          isShowFlowerAnimate.value = false;
          setTimeout(()=>{
            isShowFlowerAnimate.value = true;
            setTimeout(()=>{
              isShowFlowerAnimate.value = false;
              // 动画处理结束关闭载入loading
              setTimeout(()=>{
                appBridging.closeLoading();
              },200);
            },50)
          },50)
        },50)
      })

    });

    /**
     * 周常/og页面切换处理
     */
    const switchTagHanlde = (number) => {
      number !== currentShow.value && audioManager.playEffect("secondmenu");
      currentShow.value = number;
    }
    /**
     * 页面数据初始化
     */
    const firstInit = async () => {
      try {
        await requestGetRewardList();
      } catch (error) {
        proxy.$toast.show({
          msg: localesPackage.value?.['katharsis_toast_msg1']?.[localesEnv.value],
          type: TOAST_TYPE.ERROR,
        });
      }

      // 延后执行获取og列表
      setTimeout(async () => {
        try {
          await requestGetOgList();
        } catch (error) {
          proxy.$toast.show({
            msg: localesPackage.value?.['katharsis_toast_msg1']?.[localesEnv.value],
            type: TOAST_TYPE.ERROR,
          });
        }
      }, 500);

      if (!rewardData.value.length || !missionData.value.length) {
        return;
      }

      red_reward_show.value = handleTabRedCircle(rewardData.value, "reward");
      red_mission_show.value = handleTabRedCircle(missionData.value, "mission");

      computedLevelKep();

    };

    /**
     * 页面数据刷新
     */
    const init = async (mode = 'normal') => {
      console.log('initMode: ', mode);
      if(mode == 'normal'){
        // 正常模式刷新
        handleClaiming(false); // 重置领取按钮状态

        await requestGetRewardList();

        if (!rewardData.value.length || !missionData.value.length) {
          return;
        }

        red_reward_show.value = handleTabRedCircle(rewardData.value, "reward"); //判断reward圆点
        red_mission_show.value = handleTabRedCircle(missionData.value, "mission"); //判断Mission圆点

        computedLevelKep(); //根据总经验值计算当前等级和当前升级经验

        // 延后执行获取og列表
        setTimeout(async () => {
          await requestGetOgList();
        }, 500);
      }else if(mode == 'reward'){
        // 纯周任务
        handleClaiming(false); // 重置领取按钮状态

        await requestGetRewardList();

        if (!rewardData.value.length || !missionData.value.length) {
          return;
        }

        red_reward_show.value = handleTabRedCircle(rewardData.value, "reward"); //判断reward圆点
        red_mission_show.value = handleTabRedCircle(missionData.value, "mission"); //判断Mission圆点

        computedLevelKep(); //根据总经验值计算当前等级和当前升级经验
      }else if(mode == 'og'){
        // 纯OG
        await requestGetOgList();
      }

      if(ogConfig.value.cumulative_sign_in >= ogConfig.value.rewardData?.length || ogConfig.value.rewardData?.length === 0){
        ogConfig.value.is_og_claimable = false;
      }
    };

    /**节流使用init初始化 */
    const initRequestDelay = init;//throttle(init, 500);

    /**
     * 动态补全数组
     */
    const autoCompleHandle = (arr, fixNum = 3) => {
      const ys = arr.length % fixNum;
      const leafNum = fixNum - (ys == 0 ? fixNum : ys);
      for (let i = 0; i < leafNum; i++) {
        arr.push({ proStyle: {
          'opacity': 0
        } });
      }
      return arr;
    };

    /**
     * 请求获得任务奖励列表
     */
    const requestGetRewardList = async () => {
      return getTaskReward().then((res) => {
        const dataArr = _.get(res, "data", []) || [];

        //显示对应周期的数据
        // const _index = handleDataIndex(dataArr);

        // if (!dataArr[0]) {
        //   //无任务情况下关闭loading
        //   appBridging.closeLoading();
        //   return;
        // }

        const data = dataArr[0];
        //任务奖励列表获取
        const rewardList = _.get(data, "active_missions_rewards", []) || [];
        // console.log(data?.['active_missions_rewards']);
        const normalList = rewardList.filter(item => item.reward_type == 1 || item.reward_type == 0);
        const proList = rewardList.filter(item => item.reward_type == 2);
        const resList = [];
        const groupMax = Math.ceil(normalList.length / 5);
        for(let i = 0; i < groupMax; i++){
          // 每组遍历
          const nA = [];
          const pA = [];
          const d = i * 5;
          for(let x = 0; x < 5; x++){
            // 五组五组进入
            if(normalList?.[x + d])nA.push(normalList?.[x + d]);
            if(proList?.[x + d])pA.push(proList?.[x + d]);
          }
          resList.push(...nA,...pA);
        }
        // console.log('处理好的resList: ',resList);
        rewardData.value = [
        ...resList.map(item => {
          item.isPro = item.reward_type == 2;
          return item;
        })]; 
        // console.log('rewardData.value: ',rewardData.value);
        //pro道具升级奖励数组列表获取
        const propList = _.cloneDeep(rewardData.value)
                          .filter(item => item.isPro);
        let propListGroup = propList.reduce((acc,cur)=>{
          const found = acc.find(item => item.prop_id == cur.prop_id);
          if(found){
            found.reward_num += cur.reward_num;
          }else{
            acc.push({...cur});
          }
          return acc;
        },[])
        if(propListGroup.length == 1){
          propListGroup[0].proStyle = {'marginLeft': 'auto'}
          pro_prop_list.value = propListGroup;
        }else{
          pro_prop_list.value = autoCompleHandle(propListGroup);
        }
        missionData.value = _.get(data, "active_missions", []) || [];

        begin_time.value = _.get(data, "begin_time", 0); //倒计时
        end_time.value = _.get(data, "end_time", 0);
        isLockUpgraded.value = _.get(data, "is_upgraded", false);
        period_id.value = _.get(data, "id", "0");
        max_level.value = Math.max(...rewardList.map(item => item.level));//获取数组最大等级;
        cur_total_kep.value = _.get(data, "period_kep", 0);
        cur_weekly_kep.value = _.get(data, "weekly_kep", 0);
        arg_use.value.need = _.get(data, "pro_amount", 0);
        arg_use.value.valueTotal = _.get(data, "pro_worth_amount", 0);
        ogConfig.value.is_og_claimable = _.get(res, "is_og_claimable", false);
        ogConfig.value.is_og_enabled = _.get(res, "is_og_enabled", false);
        cur_popup_info.value = null;
      });
    };

    /**
     * 请求获取Og奖励列表
     */
    const requestGetOgList = async () => {
      return getOgList().then(res => {
        const dataArr = _.get(res, "data", []) || [];

        const data = dataArr[0];

        ogConfig.value.begin_time = _.get(data,"begin_time",0);
        ogConfig.value.end_time = _.get(data,"end_time",0);
        ogConfig.value.stars = _.get(data,"stars",0);
        ogConfig.value.rewardData = _.get(data,"rewards",[]);
        ogConfig.value.is_claimable = _.get(data, "is_claimable", false);
        ogConfig.value.cumulative_sign_in = _.get(data,"cumulative_sign_in",0);
        ogConfig.value.unlock_secs = _.get(data, "unlock_secs", 0);
        ogConfig.value.is_og_claimable = _.get(data, "is_claimable", false);

        const og_view_count = _.get(data, "view_count", 0);
        // og玩家首次进入
        if(og_view_count === 0 && ogConfig.value.stars > 0)isShowOgMessagePopup.value = true;

        // 红点逻辑更新
        if(ogConfig.value.cumulative_sign_in >= ogConfig.value.rewardData?.length){
          ogConfig.value.is_og_claimable = false;
        }
        
      })
    }

    /**
     * 判断当前显示的周期
     */
    const handleDataIndex = (data) => {
      let _index = 0;
      const currentTime = Math.floor(new Date().getTime() / 1000);
      data.forEach((item, index) => {
        if (currentTime >= item.begin_time && currentTime <= item.end_time) {
          _index = index;
        }
      });
      return _index;
    };

    /**
     * 判断 reward、mission Tab红点展示
     */
    const handleTabRedCircle = (data, type) => {
      let flag = false;
      data.forEach((_item, index) => {
        const item = JSON.parse(JSON.stringify(_item));
        if (item.state === TASK_STATE_TYPE.CLAIM) {
          if(item.reward_type == 2){
            if(isLockUpgraded.value){
              flag = true;
            }
          }else flag = true;
        }
      });
      return flag;
    };

    /**文字升级动画控制器 */
    const levelTextAnimHandle = (mode) => {
      const levelView = document.getElementById('levelTxView');
      // const level1 = document.getElementById('levelTx1');
      // const level2 = document.getElementById('levelTx2');
      // const levelTxl = document.getElementById('levelTx-l');
      // const levelTxv = document.getElementById('levelTx-v');
      // const levelTxdot = document.getElementById('levelTx-dot');
      
      switch (mode) {
        case 'set':
          levelView.setAttribute('style', 'scale: 0.5;opacity: 0.5;');//padding-top: 18px;
          // level1.setAttribute('style','font-size: 44px;opacity: 0.5;');//opacity: 0;
          // levelTxl.setAttribute('style','left: 18px;');
          // levelTxv.setAttribute('style','left: 30px;');
          // levelTxdot.setAttribute('style','left: 48px;');
          // level2.setAttribute('style','font-size: 44px;top: 0;left: 54px;opacity: 0.5;');
          break;
        case 'recover':
          levelView.setAttribute('style', '');
          // level1.setAttribute('style','');
          // levelTxl.setAttribute('style','');
          // levelTxv.setAttribute('style','');
          // levelTxdot.setAttribute('style','');
          // level2.setAttribute('style','');
          break;
        default:
          break;
      }
    } 

    /**
     * 关闭页面
     */
    const handleClosePage = () => {
      appBridging.closePage();
    };

    /**
     * 展示、关闭介绍
     */
    const showActivityIntro = (state) => {
      isShowRules.value = state;

      audioManager.playEffect("bubble");
    };

    /**
     * 处理tab切换
     */
    const handleSelect = (type) => {
      type !== tabStyle.value && audioManager.playEffect("secondmenu");

      tabStyle.value = type;
    };

    /**
     * 展示关闭 领取奖励 弹窗
     */
    const handleShowUnClaim = (state = false, draw_type) => {
      isShowNotClaim.value = state;

      if (!state) {
        audioManager.playEffect("bubble");
      }

      if (state) {
        drawClickType.value = draw_type;
      }
      
      //领取完经验后判断是否升级
      if (!state && drawClickType.value === DRAW_CLICK_TYPE.MESSION) {
        curMissionsClaimKep.value && kepUpgrade(curMissionsClaimKep.value);
      }

      //领取完奖励之后刷新页面
      if (!state && drawClickType.value === DRAW_CLICK_TYPE.REWARD) {
        if(cur_reward_item.value){
          // 单个领奖 - 领奖动画 - 处理
          const {level, reward_type} = cur_reward_item.value;
          rewardData.value = rewardData.value.map((item,index) => {
            const {level: levelItem, reward_type: rewardItem} = item;
            if(levelItem === level && reward_type === rewardItem){
              item.rewarding = true;
              item.playEffect = true;
            }else {
              item.rewarding = false;
              item.playEffect = false;
            }
            return item;
          })
        }else{
          // 多个领奖
          rewardAnimHandle();
        }
      }

      // OG奖励领取
      if(!state && drawClickType.value === DRAW_CLICK_TYPE.OG_REWARD){
        ogConfig.value.rewardAnimState = true;
      }

    };

    /**
     * 展示关闭 已领取、未解锁弹窗
     */
    const handleShowClaimedLock = (state = false) => {
      if (!state) {
        handleClaiming(false);
        audioManager.playEffect("bubble");
      }

      isShowClaimedLock.value = state;
    };

    /**
     * 展示 / 关闭，消息弹窗
     */
    const handleMsgPopHandle = async (state = false, popupType = POPUP_TYPE.UPGRADE, propItem = {}) => {
      try{
        audioManager.playEffect("bubble");
        switch (state) {
          case 'confirm':
            proxy.$loading.show(); // 显示loading
            await postUpgrade().then(res => {
              if(res.data.code == 0){
                proxy.$toast.show({
                  msg: localesPackage.value?.['og_upgrade_success_toast']?.[localesEnv.value],
                  type: TOAST_TYPE.SUCCESS,
                });
                isLockUpgraded.value = true;
                isShowClaimedLock.value = false;
                initRequestDelay('reward');
              }else{
                proxy.$toast.show({
                  msg: localesPackage.value?.['og_upgrade_fail_toast']?.[localesEnv.value],
                  type: TOAST_TYPE.ERROR,
                })
              }
              isShowMessagePopup.value = false;
            }).catch(e=>{
              //错误捕获
              const code = e?.response?.data?.code;
              if(code == 400901){
                // errorPopupHandle(1,'Insufficient ART Balance, unable to purchase.');
                errorPopupHandle(1, localesPackage.value?.['og_opps_about']?.[localesEnv.value]);
              }
            })
            proxy.$loading.hide();
            break;
          case 'upgrade':
            popup_type.value = POPUP_TYPE.UPGRADE;

            setTimeout(()=>{
              isShowClaimedLock.value = false;
              isShowMessagePopup.value = true;
            },50)
            break;
          case true:
            isShowMessagePopup.value = state;
            popup_type.value = popupType;
            cur_popup_info.value = propItem;
            break;
          case false:
            isShowMessagePopup.value = state;
            isShowClaimedLock.value = false;
            break;
          case 'rules':
            // 介绍弹窗
            popup_type.value = POPUP_TYPE.INTRO;
            isShowMessagePopup.value = state;
            break;
          default:
            console.log('eoor');
            break;
        }
      }catch(e){
        console.log(e);
      }
      
    }
    /**
     * 触发reward点击事件 接收参数
     */
    const handleRewardClick = (itemSign, state, reward_item) => {
      
      if(itemSign == 'next'){
        rewardAnimHandle();
        return;
      }
      curState.value = state;
      // console.log("物品信息: ",reward_item,"curState: ",state," itemSign: ",itemSign);
      if (state === REWARD_TYPE.UNCLAIMED) {
        cur_popup_info.value = [reward_item];
        cur_reward_item.value = itemSign;
        handleShowUnClaim(true, DRAW_CLICK_TYPE.REWARD);
      } else {
        cur_mode.value = 1;
        cur_popup_info.value = reward_item;
        handleShowClaimedLock(true);
        // computedOwnedPorpsNum(reward_item.prop_id);
      }
    };

    /**
     * 展示动画弹窗
     */
    const handleClickFlower = () => {
      isShowFlowerAnimate.value = true;
    };

    /**
     * 关闭动画弹窗
     */
    const handleCloseFlower = () => {
      isShowFlowerAnimate.value = false;
      cur_upgrade_kep.value = cur_total_kep.value % 500;
      
      firstInitTimes.value++;
      if(firstInitTimes.value > 2){
        // 防止因动画初始化带来的多次请求
        initRequestDelay('reward');
      }
    };

    /**
     * 领取经验奖励后判断升级动画
     */
    const kepUpgrade = (task_kep) => {
      // 当当前周累计经验到达5000时，不再进行周期累计经验升级
      if (cur_weekly_kep.value >= 5000) {
        initRequestDelay('reward');
        return;
      }

      let leafValue = 0;// 经验差额
      if(cur_weekly_kep.value + task_kep >= 5000){
        // 如果当前任务升级大于周限制时
        leafValue = (cur_weekly_kep.value + task_kep) - 5000;// 获得多出的经验
      }

      cur_total_kep.value = cur_total_kep.value + task_kep - leafValue; //整个周期累积的经验值
      const upgrade_kep = cur_upgrade_kep.value + task_kep; //领取奖励后的升级经验值

      //先升级经验
      // setTimeout(() => {
      //   audioManager.playEffect("expget");
      // }, 500);

      cur_upgrade_kep.value = upgrade_kep > 500 ? 500 : upgrade_kep; //限制不能超过500
      let level = Math.floor(cur_total_kep.value / 500);

      if(level >= max_level.value)level = max_level.value;// 最大显示最高等级

      //判断是否升级
      if (level > cur_level.value && level <= max_level.value) {
        setTimeout(() => {
          cur_level_anim.value = level;
          handleClickFlower(); //强制出现升级弹窗
          audioManager.playEffect("upgrade");
          curMissionsClaimKep.value = 0; //清零
          cur_upgrade_kep.value = 0;//进度条动画归零
          setTimeout(()=>{
            levelTextAnimHandle('set');
          },1234)
          setTimeout(()=>{
            // handleCloseFlower();
            cur_level.value = level;
            levelTextAnimHandle('recover');
          },1404)
        }, 1300);
      } else {
        initRequestDelay('reward');
      }
    };

    /**
     * 处理Mission中claim按钮领取经验
     */
    const handleMissionsClaim = (task_id, task_kep, missionItem) => {
      handleShowUnClaim(true, DRAW_CLICK_TYPE.MESSION);

      curMissionsClaimKep.value = task_kep; //保存当前领取的经验量

      //保存当前弹窗信息
      const { kep } = missionItem;
      cur_popup_info.value = [
        {
          ...missionItem,
          reward_num: kep,
        }
      ];
    };

    /**
     * 处理领取限制
     */
    const handleClaiming = (state,reward_item) => {
      if(state == 'unpro'){
        //pro未升级情况
        // handleMsgPopHandle(true,POPUP_TYPE.PROP,reward_item);
        cur_mode.value = 2;
        curState.value = 0;
        cur_popup_info.value = reward_item;
        audioManager.playEffect("bubble");
        handleShowClaimedLock(true);
        return;
      }
      if(state == 'error'){
        errorPopupHandle(
          1,
          localesPackage.value?.['katharsis_toast_msg1']?.[localesEnv.value]
        );
      }
      if(state == 400011){
        errorPopupHandle(
          1,
          // 'The event has ended and the rewards cannot be claimed',
          localesPackage.value?.['katharsis_error_msg1']?.[localesEnv.value]
        );
      }
      isClaiming.value = state;
    };

    /**
     * 计算当前等级、和升级的经验值
     */
    const computedLevelKep = () => {
      const levelValue = Math.floor(cur_total_kep.value / 500);
      cur_level.value = levelValue > max_level.value ? max_level.value : levelValue;
      cur_upgrade_kep.value = cur_total_kep.value % 500;
    };

    /**
     * 计算当前用户拥有的道具数量
     */
    const computedOwnedPorpsNum = (prop_id) => {
      let prop_number = 0;

      rewardData.value.forEach((item, index) => {
        if (item.prop_id === prop_id && item.state === REWARD_TYPE.CLAIMED) {
          prop_number += item.reward_num;
        }
      });

      cur_props_owned.value = prop_number;
    };

    /**
     * og道具弹窗
     */
    const ogPropPopup = (prop_item,state) => {
      cur_mode.value = 1;
      curState.value = state;
      cur_popup_info.value = prop_item;
      handleShowClaimedLock(true);
    }
    /**
     * og道具点击事件 - 领奖 | 展示弹窗
     * @param {*} prop 
     */
    const ogPropClickHandle = async (prop) => {
      const nowSignDay = ogConfig.value.cumulative_sign_in;
      const state = prop.level > nowSignDay ? 0 : 2;
      audioManager.playEffect("bubble");
      
      if(ogConfig.value.is_claimable && ogConfig.value.stars > 0 && ogConfig.value.unlock_secs == 0){
        if(prop.level === nowSignDay + 1){
          //领取事件
          proxy.$loading.show(); // 显示loading
          await postOgRewardClaim().then(res => {
            // isShowNotClaim
            if(res.data?.state === 0){
              //成功
              cur_popup_info.value = [prop];
              handleShowUnClaim(true, DRAW_CLICK_TYPE.OG_REWARD);
              appBridging.handleRefreshNativeCache('V1GetUProps');
              appBridging.handleRefreshNativeCache('V1GetChips');
              //本地展示预处理
              audioManager.playEffect("get_token");
              ogConfig.value.is_claimable = false;
              ogConfig.value.cumulative_sign_in += 1;
            }
          }).catch(error=>{
            //失败捕获
            const code = error?.response?.data?.code;
            if(code == 400005){
              //重复领取
              // reward has been claimed
              // errorPopupHandle(1,error?.response?.data?.msg,'og');
              errorPopupHandle(1, localesPackage.value?.['katharsis_error_msg3']?.[localesEnv.value],'og');
            }else if(code == 400011){
              errorPopupHandle(
                1,
                // 'The event has ended and the rewards cannot be claimed',
                localesPackage.value?.['katharsis_error_msg1']?.[localesEnv.value],
                'og'
              );
            }else{
              // errorPopupHandle(1,error?.response?.data?.msg || 'Refresh and Try Again','og');
            }
          })
          proxy.$loading.hide();
        }else ogPropPopup(prop,state);
      } else ogPropPopup(prop,state);
    }

    /**og-check领取动画 */
    const animOgCheckHandle = () => {
      ogConfig.value.rewardAnimState = false;
      cur_popup_info.value = null;
      initRequestDelay('og');
    }

    /**
     * 非OG玩家点击事件
     */
    const disOgPlayerHandle = () => {
      audioManager.playEffect("bubble");
      og_popup_type.value = POPUP_TYPE.OG_HOWTOBE;
      isShowOgMessagePopup.value = true;
    }
    /**
     * 错误弹窗
     */
    const errorPopupHandle = (error_type, error_msg, page = 'kaeharsis') => {
      console.log("error_msg: ",error_msg);
      // 存储错误信息
      error_info.value.type = error_type;
      error_info.value.msg = error_msg;
      error_info.value.platform = page;
      if(page == 'kaeharsis'){
        //周任务页
        popup_type.value = POPUP_TYPE.ERROR;  
        isShowMessagePopup.value = true;
      }else{
        //Og页面
        og_popup_type.value = POPUP_TYPE.ERROR;
        isShowOgMessagePopup.value = true;
      }
    }
    /**
     * og弹窗处理器
     */
    const handleOgMsgPopHandle = (info) => {
      audioManager.playEffect("bubble");
      switch (info) {
        case 'close':
          isShowOgMessagePopup.value = false;
          break;
        
        default:
          break;
      }
    }

    /**领奖打勾动画处理 */
    const rewardAnimHandle = () => {
      const playGroup = _.cloneDeep(rewardAnimConfig.value.animGroup);

      //执行前获取要播放的组别项号码
      rewardAnimConfig.value.nowStep = findIndexByFieldValue(playGroup,'rewarding',true);
      const nowStep = rewardAnimConfig.value.nowStep; //当前号
      //合法判断
      if(nowStep < 0){
        if(cur_reward_item.value){
          // reward页面单个领奖
          initRequestDelay('reward'); // 刷新页面
          cur_reward_item.value = null;//清除当前状态，防止下次动画污染
        }else{
          // 其他可能
          initRequestDelay(); // 刷新页面
        }
        return;
      }

      //获取当前组号
      const groupSize = rewardAnimConfig.value.playSize; //组大小 rewardAnimConfig.value.playSize
      const nowGroupNumber = Math.floor(nowStep / groupSize); //当前组号
      const nowGroupStartNum = nowGroupNumber * groupSize; //当前组号 - 组首
      const nowGroupEndNum = nowGroupStartNum + 4; //当前组号 - 组尾

      //根据组号赋值
      let setEffectFlag = true;// 多组动画只播放一次音频
      for(let i = nowGroupStartNum; i <= nowGroupEndNum; i++){
        rewardData.value[i].rewarding = playGroup[i].rewarding;
        if(playGroup[i]?.rewarding){
          rewardData.value[i].playEffect = setEffectFlag;
          rewardData.value[i].state = 2;//状态本地调整为已领取
          setEffectFlag = false;
        }else rewardData.value[i].playEffect = false;
        //恢复
        playGroup[i].rewarding = false; 
        playGroup[i].playEffect = false;
      }
      rewardAnimConfig.value.animGroup = playGroup;
    }
    /**
     * 一件领取处理
     */
    const receiveInFullHandle = async () => {
      //合法校验
      if(!(red_reward_show.value))return;
      audioManager.playEffect("bubble");
      proxy.$loading.show(); // 显示loading
      await requestGetRewardList();
      // 领奖动画状态处理
      let setEffectFlag = true;// 多组动画只播放一次音频
      rewardAnimConfig.value.animGroup = _.cloneDeep(rewardData.value).map(item => {
        if(item?.state == 1){
          item.rewarding = item.reward_type == 2 ? isLockUpgraded.value : true;
          item.playEffect = setEffectFlag;
          setEffectFlag = false;
        }else {
          item.rewarding = false;
          item.playEffect = false;
        }
        return item;
      });
      //获取本地奖励数组 -> 奖励弹窗显示奖励数组
      let rewardArr = _.cloneDeep(rewardData.value).filter(item => {
        if(item?.state == 1){
          if(item?.reward_type == 2){
            // pro奖励
            if(isLockUpgraded.value)return item;
          }else return item;
        }
      });
      // 相同物品数量叠加
      rewardArr = rewardArr.reduce((acc,cur)=>{
        const found = acc.find(item => item.prop_id == cur.prop_id);
        if(found){
          found.reward_num += cur.reward_num;
        }else{
          acc.push({...cur});
        }
        return acc;
      },[])
      if(!isLockUpgraded.value)rewardArr = rewardArr.filter(item => !item.isPro);
      const param = {
        level: 0,
        reward_type: 0,//领取全部
        period_id: '',
      };
      await postRewardClaim(param)
        .then((res) => {
          const state = _.get(res, "data.state", 0);
          const current_holding = _.get(res, "data.current_holding", 0);
          appBridging.handleRefreshNativeCache('V1GetUProps');
          appBridging.handleRefreshNativeCache('V1GetChips');
          if(current_holding > 0){
            audioManager.playEffect("get_token");
            if(rewardArr?.length < 4){
              cur_popup_info.value = rewardArr;
            } else cur_popup_info.value = autoCompleHandle(rewardArr, 4);
            handleShowUnClaim(true, DRAW_CLICK_TYPE.REWARD);
          }else{
            // errorPopupHandle(1,'Claim failed, Please try again.');
            errorPopupHandle(1, localesPackage.value?.['katharsis_error_msg2']?.[localesEnv.value]);
          }
        })
        .catch((error) => {
            console.log(error);
            const code = error?.response?.data?.code;
            if(code == 400011){
              errorPopupHandle(
                1,
                // 'The event has ended and the rewards cannot be claimed',
                localesPackage.value?.['katharsis_error_msg1']?.[localesEnv.value],
                'og'
              );
            }else{
              errorPopupHandle(1, localesPackage.value?.['katharsis_error_msg2']?.[localesEnv.value]);
            }
        });
      proxy.$loading.hide(); // 关闭loading
    }

    /**og冻结倒计时-时间回调 */
    const ogTimeHandle = (time) => {
      ogConfig.value.unlock_secs = -1;
      initRequestDelay();
    }

    /**
     * 防抖
     */
    function debounce(fun, delay) {
      return function (args) {
        let that = this;
        let _args = args;
        clearTimeout(fun.id);
        fun.id = setTimeout(function () {
          fun.call(that, _args);
        }, delay);
      };
    }

    return {
      switchTagHanlde,
      handleClosePage,
      showActivityIntro,
      handleSelect,
      handleShowUnClaim,
      handleShowClaimedLock,
      handleRewardClick,
      handleClickFlower,
      handleCloseFlower,
      handleMissionsClaim,
      handleMsgPopHandle,
      ogPropClickHandle,
      animOgCheckHandle,
      receiveInFullHandle,
      handleOgMsgPopHandle,
      disOgPlayerHandle,
      ogTimeHandle,
      debounce,
      // init,
      firstInit,
      handleClaiming,
      tabStyle,
      cur_weekly_kep,
      total_upgrade_kep,
      cur_level,
      max_level,
      cur_level_anim,
      isShowRules,
      isShowNotClaim,
      isShowClaimedLock,
      isLockUpgraded,
      isShowFlowerAnimate,
      isShowMessagePopup,
      isIos,
      popup_type,
      curState,
      cur_popup_info,
      rewardData,
      missionData,
      cur_claimed_level,
      red_reward_show,
      red_mission_show,
      cur_upgrade_kep,
      cur_props_owned,
      begin_time,
      end_time,
      period_id,
      drawClickType,
      isClaiming,
      currentShow,
      arg_use,
      pro_prop_list,
      ogConfig,
      isShowOgMessagePopup,
      og_popup_type,
      error_info,
      cur_mode,
      rewardAnimConfig,
      localesPackage,
      localesEnv
    };
  },
};
</script>

<style lang="less" scoped>
@levelTextTop: 16px;

//阻止长按操作
.longTouch {
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
img{
  pointer-events: none;
  -webkit-touch-callout: none; /*系统默认菜单被禁用*/
  -webkit-user-select: none; /*webkit浏览器*/
  -khtml-user-select: none; /*早期浏览器*/
  -moz-user-select: none; /*火狐*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
}
.task {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: black;
  overflow: hidden;
  &-top {
    height: 205.67px;
    position: relative;
    // padding-bottom: 130px;
    &-background{
      width: 100%;
      background: url("~@/assets/images/YuliApp/weeklyTask/bg_reward@2x.png")
      no-repeat top left;
      background-size: 100% 100%;
      height: 310px;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      @textStroke: 4px;
      @textShadow1: 40px;
      @textShadow2: 30px;
      @textShadow3: 10px;
      &-title{
        width: 322px;
        height: 70px;
        // background: url("~@/assets/images/YuliApp/weeklyTask/kr_title.png")
        // no-repeat top left;
        // background-size: 100% 100%;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 98px;
        // text
        color: #ffffff;
        font-size: 38px;
        font-weight: Bold Italic;
        font-family: "Josefin Sans SemiBold";
        text-align: center;
        letter-spacing: -2.52px;
        // shadow
        text-shadow: 0 1px @textStroke rgba(115, 44, 205, 1), 1px 0 @textStroke rgba(115, 44, 205, 1), -1px 0 @textStroke rgba(115, 44, 205, 1), 0 -1px @textStroke rgba(115, 44, 205, 1),
                    0 0 @textShadow1 rgba(79, 0, 255, 0.76), 0 0 @textShadow2 rgba(47, 128, 223, 0.66), 0 0 @textShadow3 rgba(167, 47, 223, 0.7);
      }
    }
    &-header {
      position: relative;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 22px;
      &-return {
        width: 64px;
        height: 32px;
        text-align: left;
        z-index: 10;
        img {
          width: 100%;
          height: 100%;
          margin-left: -4px;
        }
      }
      &-introduce {
        box-sizing: border-box;
        position: relative;
        z-index: 11;
        height: 32px;
        // padding-top: 4px;
        img {
          width: 24px;
          height: 24px;
        }
      }
      &-switch{
        font-size: 15px;
        color: #fff;
        // display: flex;
        // align-items: center;
        // justify-content: space-between;
        width: 194px;
        height: 31px;
        // background: rgba(62, 50, 134, 0.4);
        padding: 1px;
        border-radius: 20px;
        z-index: 12;
        position: relative;
        top: 4px;
        &-unClaimed{
          position: absolute;
          right: 22px;
          top: -5px;
          width: 16px;
          height: 16px;
          background: rgba(222, 75, 75, 1);
          border-radius: 50%;
          z-index: 1;
          img {
            position: absolute;
            left: 4.32px;
            bottom: 5.2px;
            width: 14px;
            height: 16px;
          }
          
        }
        &-item{
          position: absolute;
          width: 130.2px;
          padding: 6px 18px;
          // border-radius: 20px;
          background: url("~@/assets/images/YuliApp/weeklyTask/tag-normal.png")
          no-repeat top left;
          background-size: 100% 100%;
          box-sizing: border-box;
        }
        .active{
          // border: 1px solid rgb(36, 36, 36);
          // background: rgb(246, 250, 253);
          // color: rgb(35, 35, 35);
          background: url("~@/assets/images/YuliApp/weeklyTask/tag-active.png")
          no-repeat top left;
          background-size: 100% 100%;
          color: #947A59;
          font-weight: 600;
          z-index: 1;
        }
        &-left{
          left: -28px;
        }
        &-right{
          right: -7px;
        }
      }
    }
    &-main {
      margin-top: 2.32px;
      padding-right: 21px;
      display: flex;
      justify-content: space-between;
      .level{
        z-index: 1;
        position: absolute;
        left: -112px;
        top: 56px;
        // top: 114px;
        // -webkit-text-stroke: 0.5px #732CCD;
        text-shadow: #732CCD 0px 0px 8px;
        // text-shadow: 0 2px #830000, 2px 0 #830000, -2px 0 #830000, 0 -2px #830000;
        font-size: 44px;
        scale: 1;
        color: #fff;
        width: 58px;
        height: 40px;
        font-weight: 600;
        font-family: "Josefin Sans Boldtalic";
        text-align: left;
        text-rendering: optimizeLegibility;
        // letter-spacing: -4px;
        transition: all .1s;
        &-lv{
          font-size: 44px;
          position: relative;
          transition: all .1s;
          &-l{
            position: absolute;
            top: @levelTextTop;
          }
          &-v{
            position: absolute;
            left: 26px;
            top: @levelTextTop;
          }
          &-dot{
            position: absolute;
            left: 49px;
            z-index: 1;
            top: @levelTextTop;
          }
          &-level{
            font-size: 44px;
            position: absolute;
            left: 58px;
            z-index: 0;
            // letter-spacing: -4px;
            top: @levelTextTop;
            transition: all .1s;
          }
        }
      }
      .jindu {
        position: relative;
        right: -125px;
        top: 106px;
        &-title {
          position: absolute;
          z-index: 10;
          top: -41.32px;
          left: -60px;
          width: 301px;
          height: 160px;
          margin-bottom: 24px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        &-limit {
          &-title{
            opacity: 0.5;
          }
          // color: rgba(0, 0, 0, 1);
          color: rgba(255, 255, 255, 1);
          // color: rgba(167, 186, 242, 1);
          font-size: 12px;
          font-weight: 700;
          font-family: "PingFang HK";
          text-align: right;
          line-height: 14.4px;
          margin-bottom: 3px;
          position: absolute;
          z-index: 1;
          top: 70px;
          right: -22px;
          // padding-left: 5px;
        }
      }
    }
  }
  &-bottom {
    // height: calc(100% - 225px);
    // position: relative;
    // z-index: 99;
    // top: -24px;
    width: 100%;
    flex-grow: 1;
    overflow: hidden;
    position: relative;
    // background: url("~@/assets/images/YuliApp/weeklyTask/bg_bottom@2x.png")
    //   no-repeat top left;
    // background-size: 100% 100%;
    margin-top: -24px;
    // padding-top: 19px;
    //按钮
    &-button{
        z-index: 1;
        position: absolute;
        right: 10px;
        bottom: -2px;
        width: 108px;
        height: 26px;
        border-radius: 20px;
        // border: 0.5px solid rgba(0, 0, 0, 0.3);
        // background: #ffdc24ff;
        background: rgba(113, 112, 164);
        opacity: 0.5;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        font-size: 13px;
        font-weight: 600;
        font-family: "PingFang SC";
      }
    &-buttonActive{
      opacity: 1;
      background: #FBEBD0;
      color: #100C60;
    }
    &-height {
      height: 18px;
    }
    &-tab {
      // padding-left: 33px;
      // margin-bottom: 14.34px;
      margin-bottom: 12px;
      width: 100%;
      height: 44px;
      display: flex;
      align-items: center;
      position: relative;
      bottom: -42px;
      &-reward,
      &-mission {
        position: relative;
        box-sizing: border-box;
        padding-top: 8px;
        width: 96px;
        height: 44px;
        // background: url("~@/assets/images/YuliApp/weeklyTask/chooseBg.png")
        //   no-repeat top left;
        // background-size: 100% 100%;
        // background: #6973CB;
        // color: #F6FAFD;
        color: rgba(47, 12, 96, 1);
        font-size: 16px;
        font-weight: 500;
        font-family: "PingFang HK";
        text-align: center;
        line-height: 19.2px;
        margin-right: 15px;
      }
      .chooseBg{
        width: 180px;
        height: 48px;
        position: absolute;
        z-index: 1;
        left: 0;
      }
      .unchooseBg{
        width: 180px;
        height: 48px;
        position: absolute;
        z-index: 0;
        left: -24px;
      }
      .choose-misson{
        width: 180px;
        height: 48px;
        position: absolute;
        z-index: 2;
        left: -40px;
        top: 8px;
      }
      .text-active{
        // color: #2F0C60 !important;
        color: #fff;
        
      }
      //修复IOS 渲染时mission文案消失的问题
      &-mission{
        &-text{
          position: absolute;
          z-index: 10;
          width: 100%;
          height: 100%;
          top: 22px;
          left: 5px;
          font-size: 16px;
          color: #fff;
        }
      }
      .seleced {
        // background: url("~@/assets/images/YuliApp/weeklyTask/button_selected@2x.png")
        //   no-repeat top left;
        // background-size: 100% 100%;
        color: rgba(196, 219, 239, 1);
        font-weight: 700;
      }
      //未领取
      .unClaimed {
        position: absolute;
        top: 10px;
        right: -1px;
        width: 16px;
        height: 16px;
        background: rgba(222, 75, 75, 1);
        border-radius: 50%;
        z-index: 3;
        img {
          position: absolute;
          left: 4.32px;
          bottom: 5.2px;
          width: 14px;
          height: 16px;
        }
      }
    }
    &-content {
      width: 100.3%;
      height: calc(100vh - 295px);
      overflow: hidden;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      z-index: 4;
      //   padding-bottom: 30px;
      //   overflow-y: scroll;
      //   -webkit-overflow-scrolling: touch;
      &-timeview{
        position: absolute;
        // background: #F6FAFD;
        background: linear-gradient(180deg,#918BD3 0,#9289D2 100%);
        top: 0;
        z-index: 15;
        width: 100%;
      }
    }
    //隐藏滚动条
    // .task-bottom-content::-webkit-scrollbar {
    //   display: none;
    // }
    // .task-bottom-content {
    //   scrollbar-width: none;
    //   -ms-overflow-style: none;
    //   overflow-y: scroll;
    //   overflow-x: hidden;
    // }
  }
}

.og{
  // position: relative;
  width: 100%;
  height: 100vh;
  &-background{
    width: 100%;
    background: url("~@/assets/images/YuliApp/weeklyTask/og-bg.png")
    no-repeat top left;
    background-size: 100% 100%;
    height: 100%;
    position: absolute;
  }
  &-banner{
    @textStroke: 4px;
    @textShadow1: 12px;
    @textShadow2: 11px;
    @textShadow3: 10px;
    &-title{
      // width: 250px;
      width: fit-content;
      height: 55px;
      position: absolute;
      top: 110px;
      right: 28.5px;
      z-index: 1;
      white-space: nowrap;
      // text
      color: rgb(255, 255, 255);
      font-size: 35px;
      font-weight: bold;
      font-family: "Josefin Sans SemiBold";
      text-align: left;
      letter-spacing: -1.5px;
      // shadow
      text-shadow: 0 1px @textStroke rgba(115, 44, 205, 1), 1px 0 @textStroke rgba(115, 44, 205, 1), -1px 0 @textStroke rgba(115, 44, 205, 1), 0 -1px @textStroke rgba(115, 44, 205, 1),
                    0 0 @textShadow1 rgba(158, 0, 255, 1), 0 0 @textShadow2 rgba(7, 2, 255, 1), 0 0 @textShadow3 rgba(167, 47, 223, 0.7);
    }
    &-Tag{
      width: 104px;
      height: 34px;
      position: absolute;
      top: 101px;
      right: 32px;
      img{
        width: 100%;
        height: 100%;
        position: absolute;
        z-index: 2;
        right: -12px;
        top: -6px;
      }
      &-text{
        background-image: -webkit-linear-gradient(180deg,#FFF0D0 0,#FFEBC4 100%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        font-size: 12px;
        font-weight: 600;
        font-family: "PingFang HK";
        z-index: 3;
        position: absolute;
        right: 0;
      }
    }
  }
  &-level{
    width: 114px;
    height: 114px;
    position: absolute;
    left: 6px;
    top: 86px;
    color: #ffffffff;
    font-family: "Josefin Sans SemiBold";
    img{width: 100%;height: 100%;}
    &-starbox{
      position: relative;
      width: 71px;
      height: 10px;
      top: -123px;
      left: -2px;
      &-1{
        position: absolute;
        bottom: -18px;
        left: 18px;
      }
      &-2{
        position: absolute;
        bottom: -10px;
        left: 35px;
      }
      &-3{
        position: absolute;
        bottom: -5px;
        left: 52px;
      }
      &-4{
        position: absolute;
        bottom: -10px;
        left: 70px;
      }
      &-5{
        position: absolute;
        bottom: -19px;
        left: 86px;
      }
      img{width: 14px;height: 14px;}
    }
    &-mask{
      position: absolute;
      top: 68px;
      left: 50%;
      transform: translate(-50%,-50%);
      z-index: 5;
      img{
        width: 74px;
        height: 74px;
      }
      &-lock{
        top: 44%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 20px !important;
        height: 20px !important;
        position: absolute;
        z-index: 6;
      }
    }
    &-freeze{
      width: 114px;
      height: 114px;
      position: absolute;
      top: 1px;
      left: -13px;
      background-color: rgba(0,0,0,0.2);
    }
  }
  &-desc{
    width: 324px;
    height: 42px;
    color: #ffffffff;
    font-size: 12px;
    font-weight: 600;
    font-family: "PingFang HK";
    text-align: left;
    line-height: 14.4px;
    position: absolute;
    top: 225px;
    left: 50%;
    transform: translateX(-50%);
    &-link{
      width: fit-content;
      margin-top: 8px;
      color: #FC9823;
      text-decoration: underline;
    }
  }
  &-reward{
    width: 100%;
    height: calc(100% - 279px);
    position: absolute;
    bottom: 0;
    z-index: 2;
    background: url("~@/assets/images/YuliApp/weeklyTask/og-frame.png")
    no-repeat top left;
    background-size: 100% 100%;
    box-sizing: border-box;
    padding: 0 29px;
    padding-top: 43px;
    
    &-branch{
      width: 62px;
      height: 219px;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 11;
      background: url("~@/assets/images/YuliApp/weeklyTask/og-frame-branch.png")
      no-repeat top left;
      background-size: 100% 100%;
    }
    &-proplist{
      width: 100%;
      height: auto;
      max-height: 100%;
      box-sizing: border-box;
      overflow: hidden;
      overflow-y: scroll;
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      justify-content: flex-start;
      flex-wrap: wrap;
      &-prop{
        width: 79px;
        height: 79px;
        position: relative;
        &-bg{
          width: 100%;
          height: 100%;
          background: url("~@/assets/images/YuliApp/weeklyTask/og_prop_item_bg_normal.png")
          no-repeat top left;
          background-size: 100% 100%;
          position: absolute;
        }
        &-bg-receive{
          width: 98%;
          height: 98%;
          border-radius: 2px;
          border: 1px solid #ffffffff;
          z-index: 10;
          position: absolute;
        }
        .five{
          background: url("~@/assets/images/YuliApp/weeklyTask/og_prop_item_bg_5.png")
          no-repeat top left;
          background-size: 100% 100%;
        }
        &-day{
          position: absolute;
          top: 1.88px;
          left: 2.88px;
          color: #EEEBFF;
          font-size: 13px;
          font-weight: 600;
          z-index: 1;
        }
        &-icon{
          width: 56.5px;
          height: 56.5px;
          position: absolute;
          z-index: 2;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          &-mask{
            opacity: 0.5;
          }
        }
        &-reward-num{
          color: #433b73ff;
          font-size: 11.29px;
          font-weight: 500;
          font-family: "PingFang SC";
          position: absolute;
          bottom: 0;
          right: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          justify-content: flex-end;
          padding: 5px;
          box-sizing: border-box;
        }
        &-unClaimed{
          position: absolute;
          right: 0;
          top: 0;
          width: 15px;
          height: 15px;
          opacity: 1;
          background: rgba(222, 75, 75, 1);
          border-radius: 50%;
          z-index: 2;
          img {
            width: 14px;
            height: 16px;
            position: absolute;
            left: 4px;
            bottom: 3px;
            width: 11.2px;
            height: 12.8px;
            scale: 1.2;
            z-index: 10;
          }
        }
        &-claimed{
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0,0,0,0.4);
          z-index: 2;
          img {
            width: 40px;
            height: 40px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%,-50%);
            z-index: 10;
          }
        }
      }
      &-disable{
        width: calc(100vw - 58px);
        height: calc(100vh - 324px);
        background: rgba(0,0,0,0.5);
        position: absolute;
        bottom: 0;
        z-index: 1;
      }
      &-mask{
        width: calc(100vw - 58px);
        height: calc(100vh - 324px);
        box-sizing: border-box;
        position: fixed;
        bottom: 0;
        z-index: 20;
        background: rgba(0, 0,0, 0.4);
        img{
          width: 100px;
          height: 100px;
          left: 50%;
          transform: translateX(-50%);
          position: absolute;
          top: 110px;
        }
        &-text{
          left: 50%;
          transform: translateX(-50%);
          position: absolute;
          font-size: 16px;
          font-weight: 600;
          color: #fff;
          width: 100%;
          top: 230px;
        }
        &-text2{
          left: 50%;
          transform: translateX(-50%);
          position: absolute;
          font-size: 13px;
          font-weight: 400;
          color: #fff;
          width: 100%;
          text-align: center;
          top: 260px;
        }
      }
    }
    
  }
  
}

.square-with-hole {
  position: relative;
  width: 79px;
  height: 79px;
  background-color: rgba(0, 0,0, 0.4);
  z-index: 2;
}

@media screen and (width: 375px) and (height: 667px) {
  .og{
    &-reward{
      padding-top: 32px;
      &-proplist{
        &-disable{
          height: calc(100vh - 301px) !important;
        }
        &-mask{
          height: calc(100vh - 301px) !important;
        }
      }
    }
  }
}
@media screen and (width: 414px) and (height: 736px) {
  .og{
    &-reward{
      padding-top: 32px;
      &-proplist{
        &-disable{
          height: calc(100vh - 301px) !important;
        }
        &-mask{
          height: calc(100vh - 301px) !important;
        }
      }
    }
  }
}
@media screen and (width: 540px) and (height: 720px) {
  .og{
    &-reward{
      padding-top: 22px;
      height: 255px !important;
      &-proplist{
        &-disable{
          height: calc(100vh - 267px) !important;
        }
        &-mask{
          height: calc(100vh - 267px) !important;
        }
      }
    }
  }
}
@media screen and (min-width: 700px) and (min-height: 900px) {
  .og{
    &-reward{
      padding-top: 25px;
      &-proplist{
        &-disable{
          height: calc(100vh - 294px) !important;
        }
        &-mask{
          height: calc(100vh - 294px) !important;
        }
      }
    }
  }
}
</style>
